import styled from "styled-components";
import { Button } from "../../AppStyle";

export const Wrapper = styled.div`
  padding: 30px 64px;

  .left-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    color: ${({ theme }) => theme.text};
  }

  .title {
    font-size: 32px;
    font-weight: 500;

    margin-bottom: 20px;
    span {
      font-weight: bold;
    }
  }

  .description {
    font-size: 18px;
    max-width: 700px;
    margin-bottom: 30px;
    line-height: 1.4;
    word-spacing: 5px;
  }

  .right-content {
    display: grid;
    grid-template-columns: repeat(4, auto);
    grid-template-rows: repeat(3, auto);
    gap: 20px;
    flex: 1;
    align-items: center;
    min-width: 280px;
    margin-left: -64px;
    margin-right: -64px;
  }
  img {
    max-width: 100px;
    height: auto;
    object-fit: contain;
    display: block;
    margin: 0 auto;
  }

  img[src*="part-6"] {
    max-width: 40px;
  }

  @media screen and (max-width: 768px) {
    .content {
      flex-direction: column;
      align-items: flex-start;
    }

    .right-content {
      grid-template-columns: repeat(2, auto);
      justify-items: center;
    }
    .left-content {
    margin-left: -40px;
  }
  }
`;

export const HeroButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 35px;
  border-radius: 15px;
  border: none;
  background: #242424;
  color: #dddf21;
  font-size: 15px;
  font-weight: 500;

  &:hover {
    background-color: rgba(36, 36, 36, 0.54);
    color: black;
    transition-duration: 0.1s;
  }

  &:active {
    background-color: rgb(19, 19, 19);
    color: black;
    transition-duration: 0.1s;
  }

  @media screen and (max-width: 1200px) {
    width: 100%;
    max-width: 400px;
    height: 3rem;
    font-size: 17px;
    margin: 20px auto 30px;
    border-radius: 30px;
  }
`;
